module.exports = __webpack_public_path__ + "static/img/store-warn.a13f0c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/store-warn.png
// module id = DAZr
// module chunks = 58